import * as Sentry from '@sentry/browser';

import * as HairProfileService from 'Services/HairProfileService';

import { productsSlugs } from 'constants/products';

import { createApiSelectors, fetchSomething } from 'utils/reduxUtils';

import { updateCart } from '../checkoutCart/actions';
import {
  INGREDIENTS_FAILURE,
  INGREDIENTS_REQUEST,
  INGREDIENTS_SUCCESS,
  PRESCRIPTION_FAILURE,
  PRESCRIPTION_REQUEST,
  PRESCRIPTION_SUCCESS,
  ROUTINE_FAILURE,
  ROUTINE_REQUEST,
  ROUTINE_SUCCESS,
} from './actionTypes';

export const fetchPrescription = fetchSomething(
  [PRESCRIPTION_REQUEST, PRESCRIPTION_SUCCESS, PRESCRIPTION_FAILURE],
  () => HairProfileService.fetchPrescription()
);

const [getPrescriptionData, getPrescriptionError, getPrescriptionStatus] = createApiSelectors(
  state => state.prescription.formula
);

export { getPrescriptionData, getPrescriptionError, getPrescriptionStatus };

export const fetchRoutine = fetchSomething(
  [ROUTINE_REQUEST, ROUTINE_SUCCESS, ROUTINE_FAILURE],
  () => HairProfileService.fetchRoutine()
);

const [getRoutineData, getRoutineError, getRoutineStatus] = createApiSelectors(
  state => state.prescription.routine
);

export { getRoutineData, getRoutineError, getRoutineStatus };

export const fetchIngredients = fetchSomething(
  [INGREDIENTS_REQUEST, INGREDIENTS_SUCCESS, INGREDIENTS_FAILURE],
  () => HairProfileService.fetchAllIngredients()
);

const [getIngredientsData, getIngredientsError, getIngredientsStatus] = createApiSelectors(
  state => state.prescription.ingredients
);

export { getIngredientsData, getIngredientsError, getIngredientsStatus };

export const syncRoutineAndCart = (item, quantity) => async (dispatch, getState) => {
  let itemToUpdate = {
    category: item.category,
    product: {
      category: item.category,
      label: item.label,
      slug: item.variant.slug,
      unit_price: item.unit_price,
      subscription: item?.subscription,
    },
    quantity,
    type: item.product_slug,
  };
  if (quantity > 0) {
    itemToUpdate = {
      category: item.category,
      quantity,
      subscription: {
        active: item?.subscription?.subscribable,
        frequency: item?.subscription?.frequency,
      },
      type: item.product_slug,
    };
  }

  if (item.product_slug === productsSlugs.BRUSH) {
    itemToUpdate = {
      category: item.category,
      product: productsSlugs.BRUSH,
      quantity,
      type: item.variant.slug,
      customization: item.customization,
      subscription: null,
    };
  }
  return updateCart([itemToUpdate])(dispatch, getState);
};

const updateRoutineForPreselectedBrushSuccess = data => ({
  type: ROUTINE_SUCCESS,
  data,
});
const updateRoutineForPreselectedBrushFailure = error => ({
  type: ROUTINE_FAILURE,
  error,
});

export const updateRoutineForPreselectedBrush = data => async dispatch => {
  try {
    const response = await HairProfileService.postRoutine(data);
    dispatch(updateRoutineForPreselectedBrushSuccess(response));
  } catch (error) {
    dispatch(updateRoutineForPreselectedBrushFailure(error));
    Sentry.captureException(error);
  }
};
